import _ from './button.module.scss'
import React from 'react'
import {$$$, $} from '../shared/class-name'
import {TriSpinner} from './tri-spinner'
import {ButtonIcon} from './button-icon'

export const Button = ({
    children,
    onClick,
    wide,
    small,
    color,
    disabled,
    className,
    style,
    loading,
    icon,
    type = 'button'
}) => {
    const spinnerColor = {
        secondary: 'darkGray',
        danger: 'light',
        dangerSecondary: 'red',
        red: 'red',
        light: 'light',
    }[color] || 'primary'

    return <button
        type={type}
        className={$$$(
            _.button,
            $(_.wide, wide),
            $(_[color], color),
            $(_.small, small),
            $(_.loading, loading),
            $(className))}
        style={style}
        onClick={onClick}
        disabled={disabled}
    >
        <span className={_.content}>{icon && <ButtonIcon>{icon}</ButtonIcon>}{children}</span>
        {loading && <span className={_.spinner}><TriSpinner size={20} color={spinnerColor}/></span>}
    </button>
}
